import React from 'react';
import { Card } from '../ui/card';
import { Shield, Users, Zap } from 'lucide-react';

const FEATURES = [
  { icon: Shield, titulo: 'Ofertas Exclusivas', texto: 'Acceso VIP a descuentos especiales y promociones limitadas', bg: 'from-blue-50 to-cyan-50', iconBg: 'from-blue-500 to-cyan-400' },
  { icon: Users, titulo: 'Expertos Digitales', texto: 'Consejos de profesionales actualizados con las últimas tendencias', bg: 'from-purple-50 to-pink-50', iconBg: 'from-purple-500 to-pink-400' },
  { icon: Zap, titulo: 'Actualización Instantánea', texto: 'Notificaciones en tiempo real sobre nuevas oportunidades', bg: 'from-green-50 to-emerald-50', iconBg: 'from-green-500 to-emerald-400' },
];

export const FeaturesSection = () => (
  <section className="py-20 bg-white" data-testid="features-section">
    <div className="container mx-auto px-4">
      <div className="text-center mb-16">
        <h3 className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-4">¿Por qué elegirnos?</h3>
        <p className="text-xl text-slate-600 max-w-2xl mx-auto">Beneficios exclusivos para la era digital</p>
      </div>
      <div className="grid md:grid-cols-3 gap-8">
        {FEATURES.map(({ icon: Icon, titulo, texto, bg, iconBg }) => (
          <Card key={titulo} className={`bg-gradient-to-br ${bg} border-0 shadow-xl rounded-2xl p-8 text-center group hover:shadow-2xl transition-all duration-300`}>
            <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r ${iconBg} rounded-full mb-6 group-hover:scale-110 transition-transform duration-300`}>
              <Icon className="h-8 w-8 text-white" />
            </div>
            <h4 className="text-xl font-bold text-slate-800 mb-4">{titulo}</h4>
            <p className="text-slate-600">{texto}</p>
          </Card>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturesSection;
